const errorInitialState = {
    tosContent: null,
    tosCentralAgreement:null

}
//define a reducer with an initialized state action
function tos(state = errorInitialState, action) {
    //eventually adding logic to handle create, update, and delete
    switch (action.type) {
        case 'GET_TOS':
            return Object.assign({}, state, {
                tosContent: action.value,
            })
        case 'GET_CENTRALAGREEMENT_TOS':
            return Object.assign({}, state, {
                tosCentralAgreement: action.value,
            })
        case 'EMPTY_TOS':
            return errorInitialState
        default:
            return state
    }
}

export default tos